import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Card, Form, Button, Spinner, InputGroup } from 'react-bootstrap';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { useToasts } from "react-toast-notifications";
import {
  setGastosFijos,
  guardaGastosFijos,
} from "../../redux/gastosFijos/gastosFijosActions";

export const GastosFijos = () => {
  const item = { rubro: "", concepto: "", valor: "" };
  const [rubroId, setRubroId] = React.useState("");
  const rubros = ["SUELDOS", "LOCAL", "FONDO", "APOYO", "OTROS"];
  const sesion = useSelector((state) => state.sesion);
  const empresa = useSelector((state) => state.empresa);
  const gastosFijos = useSelector((state) => state.gastosFijos);
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  React.useEffect(() => {
    if (
      (!gastosFijos.dias || gastosFijos.dias === 0) &&
      (!gastosFijos.horas || gastosFijos.horas === 0) &&
      (!gastosFijos.items || gastosFijos.items.length === 0)
    ) {
      dispatch(setGastosFijos({
        dias: 20,
        horas: 8,
        items: [{ rubro: 'SUELDOS', concepto: 'Sueldo base', valor: 3000 }]
      }));
    }
    // eslint-disable-next-line
  }, []);

  const getCostoMinuto = () => {
    const dias = parseInt(gastosFijos.dias, 10) || 0;
    const horas = parseFloat(gastosFijos.horas) || 0;
    const minutosTrabajados = horas * 60 * dias;
    const totalGastos = getTotalGastos();
    const costoMinuto = minutosTrabajados > 0 ? (Math.round((totalGastos / minutosTrabajados) * 100) / 100) : 0;
    return costoMinuto;
  }

  const getCostoHora = () => {
    const dias = parseInt(gastosFijos.dias, 10) || 0;
    const horas = parseFloat(gastosFijos.horas) || 0;
    const horasTrabajadas = horas * dias;
    const totalGastos = getTotalGastos();
    const costoHora = horasTrabajadas > 0 ? (Math.round((totalGastos / horasTrabajadas) * 100) / 100) : 0;
    return costoHora;
  }

  function getTotalGastos() {
    const total = gastosFijos.items.length > 0
      ? gastosFijos.items
        .map((item) => item.valor)
        .reduce((acc, valor) => Number(acc) + Number(valor), 0)
      : 0
    return total;
  }

  const handleAddItem = (e, rubro) => {
    e.preventDefault();
    if (!rubroId) {
      addToast("Seleccione un rubro", { appearance: "error" });
      return;
    }
    dispatch(
      setGastosFijos({
        ...gastosFijos,
        items: [...gastosFijos.items, { ...item, rubro: rubro }],
      })
    );
  };

  const handleDeleteItem = (index) => {
    let valores = [...gastosFijos.items];
    valores.splice(index, 1);
    dispatch(setGastosFijos({ ...gastosFijos, items: valores }));
  };

  const handleChangeItems = (index, e) => {
    let valores = [...gastosFijos.items];
    valores[index][e.target.name] = e.target.value;
    dispatch(setGastosFijos({ ...gastosFijos, items: valores }));
  };

  const handleChangeProperty = (e) => {
    let valores = { ...gastosFijos };
    valores[e.target.name] = e.target.value;
    dispatch(setGastosFijos(valores));
  };

  const handleSave = (e) => {
    e.preventDefault();
    gastosFijos.empresaId = empresa.id;
    gastosFijos.fecha = new Date();
    gastosFijos.usuario = sesion.usuario.email;
    gastosFijos.costoMinuto = getCostoMinuto();
    gastosFijos.total = getTotalGastos();
    try {
      dispatch(guardaGastosFijos(gastosFijos));
      addToast("Se guardaron los cambios satisfactoriamente", {
        appearance: "success",
      });
    } catch (err) {
      addToast(err.message, { appearance: "error" });
    }
  };

  if (sesion.loading || sesion.loading === undefined)
    return <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
      <Spinner animation="border" role="status">
        <span className="visually-hidden"></span>
      </Spinner>
    </Container>;
  if (sesion.error) return <div>{`ocurrio un error ${sesion.error} `}</div>;

  return (
    <Container fluid="sm" className="py-4">
      <Row className="justify-content-center mb-4">
        <Col xs={12} md={12} lg={10} xl={8} xxl={7}>
          <Card className="shadow-sm">
            <Card.Body>
              <div className="mb-4">
                <Card className="bg-light border-0 shadow-sm">
                  <Card.Body className="d-flex flex-column flex-md-row justify-content-between align-items-center p-3">
                    <div className="mb-2 mb-md-0">
                      <span className="fw-bold">Costo Hora:</span>
                      <span className="ms-2 text-primary fs-5">S/ {getCostoHora() || '--'}</span>
                    </div>
                    <div>
                      <span className="fw-bold">Costo Minuto:</span>
                      <span className="ms-2 text-success fs-5">S/ {getCostoMinuto() || '--'}</span>
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <Card.Title className="mb-4 text-center" as="h3">Gastos Fijos</Card.Title>
              <Form>
                <Row className="mb-3">
                  <Col xs={12} md={6}>
                    <Form.Group controlId="dias">
                      <Form.Label>Días trabajados</Form.Label>
                      <Form.Control
                        type="number"
                        name="dias"
                        placeholder="Días trabajados"
                        value={gastosFijos.dias}
                        onChange={handleChangeProperty}
                        min={0}
                        step={1}
                        pattern="[0-9]*"
                        inputMode="numeric"
                        size="sm"
                        style={{ maxWidth: 150 }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group controlId="horas">
                      <Form.Label>Horas trabajadas</Form.Label>
                      <Form.Control
                        type="number"
                        name="horas"
                        placeholder="Horas trabajadas"
                        value={gastosFijos.horas}
                        onChange={handleChangeProperty}
                        min={0}
                        size="sm"
                        style={{ maxWidth: 150 }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="align-items-end mb-3">
                  <Col xs={12} md={8}>
                    <Form.Group controlId="rubro">
                      <Form.Label>Rubro</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <AddCircleIcon style={{ color: '#0d6efd' }} />
                        </InputGroup.Text>
                        <Form.Select
                          value={rubroId}
                          onChange={(e) => setRubroId(e.target.value)}
                          required
                        >
                          <option hidden value="">Seleccione Rubro</option>
                          {rubros.map((rubro) => (
                            <option key={rubro} value={rubro}>{rubro}</option>
                          ))}
                        </Form.Select>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4} className="text-end mt-2 mt-md-0">
                    <Button variant="primary" className="d-flex align-items-center w-100 justify-content-center justify-content-md-end" onClick={(e) => handleAddItem(e, rubroId)}>
                      <AddCircleIcon style={{ marginRight: 6 }} /> Agregar
                    </Button>
                  </Col>
                </Row>
                <div className="mb-3">
                  {gastosFijos.items.map((item, index) => (
                    <Row key={index} className="align-items-center mb-2 g-2 flex-wrap">
                      {/* Desktop/Tablet: horizontal, Mobile: stacked */}
                      <Col xs={12} md={3} className="pe-md-1">
                        <Form.Control
                          name="rubro"
                          value={item.rubro}
                          readOnly
                          plaintext
                          style={{ minWidth: 80 }}
                        />
                      </Col>
                      <Col xs={12} md={4} className="pe-md-1">
                        <Form.Control
                          name="concepto"
                          placeholder="Concepto"
                          type="text"
                          autoComplete="off"
                          value={item.concepto}
                          onChange={(e) => handleChangeItems(index, e)}
                          style={{ minWidth: 100 }}
                        />
                      </Col>
                      <Col xs={8} md={3} className="pe-md-1">
                        <InputGroup>
                          <InputGroup.Text>S/</InputGroup.Text>
                          <Form.Control
                            name="valor"
                            placeholder="Valor"
                            type="number"
                            autoComplete="off"
                            value={item.valor}
                            onChange={(e) => handleChangeItems(index, e)}
                            min={0}
                            style={{ minWidth: 70 }}
                          />
                        </InputGroup>
                      </Col>
                      <Col xs={4} md={2} className="text-end">
                        <Button variant="outline-danger" size="sm" className="w-100" onClick={() => handleDeleteItem(index)}>
                          <CancelIcon />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <div className="fw-bold text-end" style={{ fontSize: '1rem' }}>
                    Total: <span className="text-success">S/ {getTotalGastos()}</span>
                  </div>
                </div>
                <div className="text-end">
                  <Button variant="primary" onClick={handleSave}>Guardar</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
